import { render, staticRenderFns } from "./livescores.vue?vue&type=template&id=188c3f12&scoped=true&"
import script from "./livescores.vue?vue&type=script&lang=js&"
export * from "./livescores.vue?vue&type=script&lang=js&"
import style0 from "./livescores.vue?vue&type=style&index=0&id=188c3f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c3f12",
  null
  
)

export default component.exports